export const notifications = [

  {
    image: "https://via.placeholder.com/150",
    titleKey: "notification.albumPosted",
    time: "4:10 PM",
    icon: "thumb-up gx-text-blue",
  }, {
    image: "https://via.placeholder.com/150",
    titleKey: "notification.sharedPost",
    time: "5:18 PM",
    icon: "chat gx-text-grey",
  }, {
    image:"https://via.placeholder.com/150",
    titleKey: "notification.groupInvitation",
    time: "5:36 PM",
    icon: "birthday text-info",
  }, {
    image:"https://via.placeholder.com/150",
    titleKey: "notification.birthday",
    time: "5:54 PM",
    icon: "birthday gx-text-warning",
  }, {
    image: "https://via.placeholder.com/150",
    titleKey: "notification.profileUpdated",
    time: "5:25 PM",
    icon: "profile gx-text-grey",
  }
];
